export default "__VITE_ASSET__02e13607__"